export const VOICE_FEATURES = {
  TRUNK: 'TRUNK',
  SERVICE: 'SERVICE',
};

export const FEATURE_FEATURES = {
  ACCOUNT: 'ACCOUNT',
  CALLFORWARDING: 'CALLFORWARDING',
  STIRSHAKEN: 'STIRSHAKEN',
  CNAMREPUTATION: 'CNAMREPUTATION',
  DOMAIN: 'DOMAIN',
  CALLERID: 'CALLERID',
  PIN: 'PIN',
  RELEASE: 'RELEASE',
};

export const MESSAGING_FEATURES = {
  MESSAGING: 'MESSAGING',
};

export const PROVISION_FEATURES = {
  ...VOICE_FEATURES,
  ...FEATURE_FEATURES,
  ...MESSAGING_FEATURES,
};

export const FEATURE_PATHS = {
  TRUNK: 'voiceSettings.trunkSettings',
  CALLFORWARDING: 'voiceSettings.callForwardingSettings',
  STIRSHAKEN: 'voiceSettings.stirShakenSettings',
  CNAMREPUTATION: 'voiceSettings.inboundCnamSettings',
  DOMAIN: 'voiceSettings.netsapiensSettings',
  CALLERID: 'voiceSettings.outboundCallerSettings',
  PIN: 'voiceSettings.portOutSettings',
  MESSAGING: 'messagingSettings',
  SERVICE: 'voiceSettings.serviceSettings',
}

export const ALL_NUMBER_FEATURES = {
  ORDER: 'ORDER',
  CREATEDID: 'CREATEDID',
  ...VOICE_FEATURES,
  ...FEATURE_FEATURES,
  ...MESSAGING_FEATURES,
  TF_ACTIVATION: 'TF_ACTIVATION'
};

export const ORDER_PROVISION_STAGES = {
  ReceiveMessage: 'ReceiveMessage',
  StopAndFailFeature: 'StopAndFailFeature',
  SucceedAndContinueFeature: 'SucceedAndContinueFeature',
  ProcessDidOrdered: 'ProcessDidOrdered',
  ProcessProvisionDid: 'ProcessProvisionDid',
  CheckDid: 'CheckDid',
  CreateDid: 'CreateDid',
  ReleaseCpaasDID: 'ReleaseCpaasDID',
  ReleaseNativeTN: 'ReleaseNativeTN',
  ReleaseE911: 'ReleaseE911',
  ProvisionSetup: 'ProvisionSetup',
  ProvisionFeature: 'ProvisionFeature',
  UpdateDid: 'UpdateDid',
  CheckMessaging: 'CheckMessaging',
  ProvisionCampaign: 'ProvisionCampaign',
  ProvisionNetNumber: 'ProvisionNetNumber',
  MonitorNetNumber: 'MonitorNetNumber',
  ProvisionSyniverse: 'ProvisionSyniverse',
  MonitorSyniverse: 'MonitorSyniverse',
  ProvisionSmsc: 'ProvisionSmsc',
  CalculateOrderStatus: 'CalculateOrderStatus',
  CheckNewNumberOrderProvisionExpire: 'CheckNewNumberOrderProvisionExpire',
};

export const TF_ACTIVATION_STAGES = {
  ReceiveMessage: 'ReceiveMessage',
  SetupAfterSomosMCP0432: 'SetupAfterSomosMCP0432',
  PeerlessLoadTo0432: 'PeerlessLoadTo0432',
  PeerlessLoadTo0432Event: 'PeerlessLoadTo0432Event',
  MonitorSomosMCP0432: 'MonitorSomosMCP0432',
  PeerlessLoadToLCRTemplate: 'PeerlessLoadToLCRTemplate',
  PeerlessLoadToLCRTemplateEvent: 'PeerlessLoadToLCRTemplateEvent',
  SomosMCPFinal: 'SomosMCPFinal',
  MonitorSomosMCPFinal: 'MonitorSomosMCPFinal',
};

export const SERVICE_PROVISION_STAGES = {
  ServiceCheck: 'ServiceCheck',
  ServiceUnprovisionOther: 'ServcieUnProvisionOther',
  ServiceProvision: 'ServiceProvision',
  ServicePreProvision: 'ServicePreProvision',
  ServicePreProvisionCancel: 'ServicePreProvisionCancel',
  ServicePostProvision: 'ServicePostProvision',
  ServiceRemoveE911Endpoint: 'ServiceRemoveE911Endpoint',
  ServiceMonitorE911EndpointRemoval: 'ServiceMonitorE911EndpointRemoval',
  ServiceRemoveE911Geolocation: 'ServiceRemoveE911Geolocation',
  ServiceMonitorE911GeolocationRemoval: 'ServiceMonitorE911GeolocationRemoval',
  ServiceUpdateTN: 'ServiceUpdateTN',

  PortServicePreProvision: 'PortServicePreProvision',
  PortServicePreProvisionCancel: 'PortServicePreProvisionCancel',
};

export const ALL_ORDER_PROVISION_STAGES = {
  ...ORDER_PROVISION_STAGES,
  ...TF_ACTIVATION_STAGES,
  ...SERVICE_PROVISION_STAGES,
}

export interface EventMessage {
  eventType: string;
  provisionOrderId: string;
  orderId: string;
  did: string;
  feature: string;
  asyncId?: string;
  retryCount?: number;
  calculateStatusesForAllDids?: boolean;
  nextEventType?: string;
  customerId?: number | null | undefined;
  provisionType?: string;
  tnE164?: string;
  bigOrder?: boolean;
  preProvisionServiceId?: string;
}

export const ORDER_EVENTS = {
  DID_ORDERED: 'DID_ORDERED',
  DID_CREATED: 'DID_CREATED',
  PROVISION_DID: 'PROVISION_DID',
  CALCULATE_NEW_NUMBER_STATUS: 'CALCULATE_NEW_NUMBER_STATUS',
  CALCULATE_VOICE_STATUS: 'CALCULATE_VOICE_STATUS',
  CALCULATE_FEATURE_STATUS: 'CALCULATE_FEATURE_STATUS',
  CALCULATE_MESSAGING_STATUS: 'CALCULATE_MESSAGING_STATUS',
  CHECK_NEW_NUMBER_ORDER_PROVISION_EXPIRE: 'CHECK_NEW_NUMBER_ORDER_PROVISION_EXPIRE',
};

export const CREATE_DID_PROVISION_EVENTS = {
  CHECK_DID: 'CHECK_DID',
  CREATE_DID: 'CREATE_DID',
};

export const RELEASE_PROVISION_EVENTS = {
  RELEASE_CPAAS_DID: 'RELEASE_CPAAS_DID',
  RELEASE_NATIVE_TN: 'RELEASE_NATIVE_TN',
  RELEASE_E911: 'RELEASE_E911',
};

export const ACCOUNT_PROVISION_EVENTS = {
  UPDATE_DID_ACCOUNT: 'UPDATE_DID_ACCOUNT',
};

export const TRUNK_PROVISION_EVENTS = {
  PROVISION_TRUNK: 'PROVISION_TRUNK',
  UPDATE_DID_TRUNK: 'UPDATE_DID_TRUNK',
};

export const CALL_FORWARDING_PROVISION_EVENTS = {
  PROVISION_CALL_FORWARDING: 'PROVISION_CALL_FORWARDING',
  UPDATE_DID_CALL_FORWARDING: 'UPDATE_DID_CALL_FORWARDING',
};

export const STIR_SHAKEN_PROVISION_EVENTS = {
  PROVISION_STIR_SHAKEN: 'PROVISION_STIR_SHAKEN',
  UPDATE_DID_STIR_SHAKEN: 'UPDATE_DID_STIR_SHAKEN',
};

export const CNAM_REPUTATION_PROVISION_EVENTS = {
  PROVISION_CNAM_REPUTATION: 'PROVISION_CNAM_REPUTATION',
  UPDATE_DID_CNAM_REPUTATION: 'UPDATE_DID_CNAM_REPUTATION',
};

export const DOMAIN_PROVISION_EVENTS = {
  PROVISION_DOMAIN: 'PROVISION_DOMAIN',
  UPDATE_DID_DOMAIN: 'UPDATE_DID_DOMAIN',
};

export const CALLERID_PROVISION_EVENTS = {
  PROVISION_CALLERID: 'PROVISION_CALLERID',
  UPDATE_DID_CALLERID: 'UPDATE_DID_CALLERID',
};

export const PIN_PROVISION_EVENTS = {
  UPDATE_DID_PIN: 'UPDATE_DID_PIN',
};

export const MESSAGING_PROVISION_EVENTS = {
  CHECK_MESSAGING: 'CHECK_MESSAGING',
  PROVISION_CAMPAIGN: 'PROVISION_CAMPAIGN',
  PROVISION_NETNUMBER: 'PROVISION_NETNUMBER',
  MONITOR_NETNUMBER: 'MONITOR_NETNUMBER',
  PROVISION_SYNIVERSE: 'PROVISION_SYNIVERSE',
  MONITOR_SYNIVERSE: 'MONITOR_SYNIVERSE',
  PROVISION_SMSC: 'PROVISION_SMSC',
  UPDATE_DID_MESSAGING: 'UPDATE_DID_MESSAGING',
};

export const TFActivationTemplates = {
  p1: 'PEERLESS_LOAD_TO_0222',
  p2: 'PEERLESS_LOAD_TO_LCRTEMPLATE',
  s1: 'SOMOS_MCP_0222',
  s2: 'SOMOS_MCP_FINAL',
}

export const TF_ACTIVATION_EVENTS = {
  TF_SETUP: 'TF_SETUP',
  TF_P1: 'TF_P1',
  TF_MONITOR_S1: 'TF_MONITOR_S1',
  TF_P2: 'TF_P2',
  TF_S2: 'TF_S2',
  TF_MONITOR_S2: 'TF_MONITOR_S2',
};

export const SERVICE_PROVISION_EVENTS = {
  SERVICE_CHECK: 'SERVICE_CHECK',
  SERVICE_UNPROVISION_OTHER: 'SERVICE_UNPROVISION_OTHER',
  SERVICE_PROVISION: 'SERVICE_PROVISION',
  SERVICE_PRE_PROVISION: 'SERVICE_PRE_PROVISION',
  SERVICE_POST_PROVISION: 'SERVICE_POST_PROVISION',
  SERVICE_PRE_PROVISION_CANCEL: 'SERVICE_PRE_PROVISION_CANCEL',
  SERVICE_PRE_PROVISION_UNDO: 'SERVICE_PRE_PROVISION_UNDO',
  SERVICE_REMOVE_E911_ENDPOINT: 'SERVICE_REMOVE_E911_ENDPOINT',
  SERVICE_MONITOR_E911_ENDPOINT_REMOVAL: 'SERVICE_MONITOR_E911_ENDPOINT_REMOVAL',
  SERVICE_REMOVE_E911_GEOLOCATION: 'SERVICE_REMOVE_E911_GEOLOCATION',
  SERVICE_MONITOR_E911_GEOLOCATION_REMOVAL: 'SERVICE_MONITOR_E911_GEOLOCATION_REMOVAL',
  SERVICE_UPDATE_TN: 'SERVICE_UPDATE_TN',

  PORT_SERVICE_PRE_PROVISION: 'PORT_SERVICE_PRE_PROVISION',
  PORT_SERVICE_PRE_PROVISION_CANCEL: 'PORT_SERVICE_PRE_PROVISION_CANCEL',
}

export const FEATURE_PROVISION_EVENTS_MAP = {
  ORDER: ORDER_EVENTS,
  CREATEDID: CREATE_DID_PROVISION_EVENTS,
  RELEASE: RELEASE_PROVISION_EVENTS,
  ACCOUNT: ACCOUNT_PROVISION_EVENTS,
  TRUNK: TRUNK_PROVISION_EVENTS,
  CALLFORWARDING: CALL_FORWARDING_PROVISION_EVENTS,
  STIRSHAKEN: STIR_SHAKEN_PROVISION_EVENTS,
  CNAMREPUTATION: CNAM_REPUTATION_PROVISION_EVENTS,
  DOMAIN: DOMAIN_PROVISION_EVENTS,
  CALLERID: CALLERID_PROVISION_EVENTS,
  PIN: PIN_PROVISION_EVENTS,
  MESSAGING: MESSAGING_PROVISION_EVENTS,
  TF_ACTIVATION: TF_ACTIVATION_EVENTS,
  SERVICE: SERVICE_PROVISION_EVENTS,
};

export const CpaasOrderStatuses = {
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  PARTIAL_FAILED: 'PARTIAL_FAILED',
};

export const ErrorRetryTag = 'CPAAS-Error-Retry:';
export const AreaUnknownTag = 'CPAAS-Area-Unknown:';

export const BILLING_ACTION_TYPES = {
  CREATE_DID: 'CREATE_DID',
  REMOVE_DID: 'REMOVE_DID',
  REACTIVATE_DID: 'REACTIVATE_DID',

  ADD_ACCOUNT: 'ADD_ACCOUNT',
  REMOVE_ACCOUNT: 'REMOVE_ACCOUNT',

  ADD_TRUNK: 'ADD_TRUNK',
  UPDATE_TRUNK: 'UPDATE_TRUNK',
  REMOVE_TRUNK: 'REMOVE_TRUNK',

  ADD_CALLFORWARDING: 'ADD_CALLFORWARDING',
  UPDATE_CALLFORWARDING: 'UPDATE_CALLFORWARDING',
  REMOVE_CALLFORWARDING: 'REMOVE_CALLFORWARDING',

  ADD_CALLERID: 'ADD_CALLERID',
  UPDATE_CALLERID: 'UPDATECALLERID',
  REMOVE_CALLERID: 'REMOVE_CALLERID',

  ADD_STIRSHAKEN: 'ADD_STIRSHAKEN',
  UPDATE_STIRSHAKEN: 'UPDATE_STIRSHAKEN',
  REMOVE_STIRSHAKEN: 'REMOVE_STIRSHAKEN',

  ADD_CNAMREPUTATION: 'ADD_CNAMREPUTATION',
  UPDATE_CNAMREPUTATION: 'UPDATE_CNAMREPUTATION',
  REMOVE_CNAMREPUTATION: 'REMOVE_CNAMREPUTATION',

  ADD_DOMAIN: 'ADD_DOMAIN',
  UPDATE_DOMAIN: 'UPDATE_DOMAIN',
  REMOVE_DOMAIN: 'REMOVE_DOMAIN',

  ADD_PIN: 'ADD_PIN',
  UPDATE_PIN: 'UPDATE_PIN',
  REMOVE_PIN: 'REMOVE_PIN',

  ADD_SMS: 'ADD_SMS',
  UPDATE_SMS: 'UPDATE_SMS',
  REMOVE_SMS: 'REMOVE_SMS',

  ADD_SERVICE: 'ADD_SERVICE',
  UPDATE_SERVICE: 'UPDATE_SERVICE',
  REMOVE_SERVICE: 'REMOVE_SERVICE',
};

export const FEATURE_PROVISION_INTERVENTION_KEY_PREFIX = 'CpaasFeatureRetryIntervention';
export const FEATURE_PROVISION_INTERVENTION_TYPES = {
  StopAndFail: 'StopAndFail',
  ProvisionSucceedAndContinue: 'ProvisionSucceedAndContinue',
  Skip: 'Skip',
}

export const CPAAS_PROVISION_COUNTER_PREFIX = 'CpaasProvCount';
export const CPAAS_PROVISION_COUNTER_TYPES = {
  NEW: 'new',
  VOICE: 'voice',
  FEATURE: 'feature',
  MESSAGING: 'messaging',
  RELEASE: 'release',
}

export const CPAAS_PROVISION_LOCK_PREFIX = 'CpaasDidProvLock';

export const CPAAS_PROVISION_ORDER_PREFIX = 'CpaasProvOrder';

export interface DIDINFO {
  didNumber?: string;
  didType?: string;
  didStatus?: string;
  accountId?: number;
  area?: string;
  trunkId?: number;
  pin?: string;
  callForwardNumber?: string;
  noIdentityHeaderPolicy?: string;
  certificateRepositoryErrorPolicy?: string;
  invalidIdentityHeaderPolicy?: string;
  cnamDippingEnable?: boolean;
  reputationScoreEnable?: boolean;
  warningReputationScore?: number;
  alarmingReputationScore?: number;
  reputationActionForWarning?: string;
  reputationActionForAlarming?: string;
  domainId?: number;
  cname?: string;
  cnamEnabled?: boolean;
  smsEnabled?: boolean;
  smsConfigId?: number;
  a2P?: boolean;
  campaignId?: string;
  mmsEnabled?: boolean;
  mmsRouteId?: number;
  sansayTrunkId?: string;
  domain?: string;
  den?: string;
  atl?: string;
  nnidNumber?: number;
  nnidIsA2P?: boolean;
  serviceCustomerId?: number;
  voiceServiceId?: string;
  messagingServiceId?: string;
  tnPortStatus?: string;
  tnE164?: string;
}

export const DEFAULT_FEATURE_VALUES = {
  trunkId: null,
  sansayTrunkId: null,
  pin: null,
  cnamEnabled: false,
  cname: null,
  domainId: null,
  domain: null,
  callForwardNumber: null,
  nnidNumber: null,
  a2P: false,
  atl: null,
  den: null,
  nnidIsA2P: null,
  smsEnabled: false,
  smsConfigId: null,
  campaignId: null,
  mmsEnabled: false,
  mmsRouteId: null,
  noIdentityHeaderPolicy: 'NONE',
  invalidIdentityHeaderPolicy: 'NONE',
  certificateRepositoryErrorPolicy: 'NONE',
  cnamDippingEnable: false,
  reputationScoreEnable: false,
  warningReputationScore: null,
  alarmingReputationScore: null,
  reputationActionForWarning: 'NO_CID_CHANGE',
  reputationActionForAlarming: 'NO_CID_CHANGE',
  voiceServiceId: null,
  messagingServiceId: null,
}

export interface TRUNK_ACCOUNT_IDENTIFIER_ROUTING {
  customerName: string,
  accountNumber: string,
  accountIdentifier: string,
  serviceProviderTrunks: {
    serviceProviderId: string,
    trunks: ({
      trunkId: string,
      comment: string,
    }[])[],
  }[],
  subscriberRatePlan: string,
  productAssigned: string,
}

export interface DID_TRUNK_ACCOUNT_IDENTIFIER_ROUTING {
  accountNumber: string,
  accountIdentifier: string,
  serviceProviderId: string,
  comment: string,
}

export const MAX_ORDER_DID_COUNT = 10000;
